'use strict';

import React, {Component} from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import classnames from "classnames";

import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";

import optionalChargesStore from "./OptionalChargesStore";
import {Campus} from '@uw-it-sis/lib-react/lib/AppConstants';

class OpChargeUSAS extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.store = optionalChargesStore;
    }

    handleChange = (e) => {
        const {name, value} = e.target;
        this.store.updateFormData(name, value);
    }

    submitForm = (e) => {
        e.preventDefault();
        this.props.onSuccess();
    }

    render() {
        const campus = this.props.campus;
        const data = this.store.data;
        const formData = this.store.formData;

        if (campus !== Campus.seattle) {
            return null;
        } else {
            const amount = Number(data.uwusas_amt) > 0 ? Number(data.uwusas_amt).toFixed(2) : "2.00"; //...default amount if the charge is not in the SDB tables yet

            let form;
            if (data.uwusas_update_sw !== "Y") { //...Update deadline for the UW USAS charge has passed already
                let nextButton;
                if (this.props.showButton) {
                    nextButton = <div><Button onClick={this.props.onSuccess}>Continue</Button></div>
                }
                if (data.uwusas_sw !== "Y") {
                    form =
                        <>
                            <p>It is past the deadline to make a contribution to UW USAS.</p>
                            <p>No, I am not contributing to UW USAS.</p>
                            {nextButton}
                        </>
                } else {
                    form =
                        <>
                            <p>It is past the deadline to change your contribution to UW USAS.</p>
                            <p>Yes, I am contributing ${amount} to UW USAS.</p>
                            {nextButton}
                        </>
                }
            } else {
                let disableButton = formData.UWUSAS !== "Y" && formData.UWUSAS !== "N";
                form =
                    <Form onSubmit={this.submitForm}>
                        <fieldset>
                            <legend className="h3">UW United Students Against Sweatshops contribution:</legend>
                            <Form.Check
                                label={`Yes, add $${amount} for UW USAS to my bill`}
                                name="UWUSAS"
                                type="radio"
                                value="Y"
                                defaultChecked={formData.UWUSAS === "Y"}
                                onChange={this.handleChange}
                                id="uwusas-yes"
                            />
                            <Form.Check
                                label={`No`}
                                name="UWUSAS"
                                type="radio"
                                value="N"
                                defaultChecked={formData.UWUSAS === "N"}
                                onChange={this.handleChange}
                                id="uwusas-no"
                            />
                        </fieldset>
                        <Button aria-disabled={disableButton} type="submit" className={classnames({"disabled": disableButton})}>Continue</Button>
                    </Form>
            }

            return (
                <>
                    <h4 className="h2">UW United Students Against Sweatshops</h4>
                    <p>
                        United Students Against Sweatshops (USAS) is a grassroots student organization whose mission is to promote and defend the rights of UW
                        students and workers.If you choose to contribute to UW USAS, ${amount} will be added to your tuition statement. Additional information
                        may be obtained through the <a href='http://uwseattle.usas.org' target='_blank'>UW USAS website</a>
                    </p>
                    {form}
                </>
            )
        }
    }
}

OpChargeUSAS.propTypes = {
    campus: PropTypes.string.isRequired,
    showButton: PropTypes.bool
}

OpChargeUSAS.defaultProps = {
    showButton: false
}

export default observer(OpChargeUSAS);